import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { SecurityService } from './security.service';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(private router: Router, private securityService: SecurityService) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      return this.securityService.validateRoute(state.url);
  }
}
